import { render, staticRenderFns } from "./TestEquipmentMeasurementSpecificationEditor.vue?vue&type=template&id=56b0c835"
import script from "./TestEquipmentMeasurementSpecificationEditor.vue?vue&type=script&lang=ts"
export * from "./TestEquipmentMeasurementSpecificationEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports